'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { InlinePromoBanner } from '@flipster/features/src/banners/inline-promo-banner';
import { useCheckSpotOnly } from '@flipster/features/src/shared/regulation';
import { useBreakpoint } from '@flipster/react/misc/responsive';
import { css } from '@flipster/styled-system/css';
import segment from '@flipster/utils/segment';
import { TradeEvent } from '@flipster/utils/segment/events/trade';

import { fomoBannerBunja } from '../fomo-banner/bunja';
import { tradeSymbolBunja } from '../symbol';

export const TradFiOrderFormBanner = () => {
  const { isTradFiInstrumentAtom } = useBunja(tradeSymbolBunja);
  const isTradFi = useAtomValue(isTradFiInstrumentAtom);

  const { fomoBannerReadyAtom } = useBunja(fomoBannerBunja);
  const { isMobile } = useBreakpoint();
  const isSpotOnly = useCheckSpotOnly();
  const isFomoBannerVisible = useAtomValue(fomoBannerReadyAtom) && !isMobile && !isSpotOnly;

  return (
    <InlinePromoBanner
      variant='TRADFI_ORDER_FORM'
      enabled={isTradFi}
      onView={(banner) =>
        segment.track(TradeEvent.TradFiOrderFormBannerView, {
          segment_id: banner.segmentId,
          image_name: banner.title,
        })
      }
      onClickCta={(banner) =>
        segment.track(TradeEvent.TradFiOrderFormBannerClick, {
          segment_id: banner.segmentId,
          image_name: banner.title,
          button_url: banner.webLink ?? '',
        })
      }
      classNames={{
        root: css({
          position: 'fixed',
          bottom: isFomoBannerVisible ? 'calc(var(--fomo-banner-height) + var(--grid-space) + 8px)' : 8,
          right: 8,
          zIndex: 101, // orderform 로그인/가입 버튼 zindex(100) 위에 노출되도록 (fomo-banner와 동일 기준)
          maxW: 300,
          rounded: 12,
          bgColor: 'background.default.level-0',
        }),
      }}
    />
  );
};
